<script>
export default {
  name: 'DonateActionButton',
  components: {
    CpButton: require('../../button').default,
    CpBaseSvgIcon: require('../../base-svg-icon').default,
    DonateIcon: require('../../social-feed/icons/donate').default,
  },
  props: {
    id: [String, Number],
    type: String,
    link: String,
  },
  methods: {
    contribute() {
      if (this.type == 'crowdpac') {
        window.location.href = '/contribute/' + this.id;
      } else if (this.type == 'candidate') {
        window.location.href = this.link;
      }
    },
  },
};
</script>

<template>
  <div>
    <cp-button noborder bold @click="contribute()">
      <cp-base-svg-icon style="margin-right: 5px" :width="23" :height="25" viewBox="0 0 90 69" icon-color="var(--primary-blue-400)" :stroke-color="'none'">
        <donate-icon />
      </cp-base-svg-icon>

      <span v-if="!$root.isMobile" class="body primary-blue-400-color">Donate</span>
    </cp-button>
  </div>
</template>

<style scoped>
.button--darkgray-outline {
  transition: color 0.2s ease;
}
</style>
